import { apiClient } from './api';
import type {
  ProgramCatalogResponse,
  ProgramCatalogProgram,
  ProgramCatalogImportResponse,
} from './types';

export class ProgramCatalogService {
  private static readonly ENDPOINT = '/api/program-catalog';

  static async getAll(): Promise<ProgramCatalogProgram[]> {
    const response = await apiClient.get<ProgramCatalogResponse>(this.ENDPOINT);
    return response.data.programs;
  }

  static async importProgram(slug: string): Promise<ProgramCatalogImportResponse> {
    const response = await apiClient.post<ProgramCatalogImportResponse>(`${this.ENDPOINT}/${slug}/import`);
    return response.data;
  }
}
